import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, shallowEqual, useDispatch } from 'dva'
import { message } from 'antd'
import Form from 'rc-field-form'
import { FormItem } from 'components'
import { Password, Input } from 'app/login/components'
import { Button } from 'components'
import Inspect from '../inspect'
import styles from './index.module.less'

const selector = ({ login, loading }) => ({
  limit: login.limit,
  loading: ['login/onGeetest', 'login/login'].some(
    item => loading.effects[item]
  ),
})
export default function Index() {
  const dispatch = useDispatch()
  const { limit, loading } = useSelector(selector, shallowEqual)

  const [inspectShow, setInspectShow] = useState(false)
  const [formSubmit, setFormSubmit] = useState(0)
  const [clickTime, setClickTime] = useState(true)

  const history = useHistory()
  const [form] = Form.useForm()

  const __dev__ = process.env.NODE_ENV === 'development'
  const initialValues = {
    workId: __dev__ ? 'YGADMIN' : '',
    password: __dev__ ? 'qa123456' : '',
  }

  const onFinish = async values => {
    if (!clickTime) return message.error('操作频繁，请稍后再试')
    setClickTime(false)
    setTimeout(() => setClickTime(true), 2000)

    let res: any = await dispatch({
      type: 'login/login',
      payload: {
        ...values,
        limit,
        loginType: 'id',
        doubleFactor: true,
        history,
      },
    })
    if (res?.code === '000') {
      await dispatch({ type: 'session/setUserInfo', payload: res.data })
      setInspectShow(true)
    }
  }

  return (
    <>
      <Form
        form={form}
        className={styles.idLogin}
        initialValues={initialValues}
        onFinish={onFinish}>
        <div className={styles.formItem}>
          <FormItem
            name="workId"
            rules={[{ required: true, message: '请输入工号' }]}>
            <Input placeholder="请输入工号" />
          </FormItem>
        </div>
        <div className={styles.formItem}>
          <FormItem
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}>
            <Password placeholder="请输入密码" />
          </FormItem>
        </div>
        <Button type="primary" htmlType="submit" loading={loading}>
          登 录
        </Button>
        <span
          className={styles.forget}
          onClick={() => history.push('/reset-password?hideWxQuick=true')}>
          忘记密码
        </span>
      </Form>
      {inspectShow && <Inspect goBack={() => setInspectShow(false)} />}
    </>
  )
}
